module.exports = __webpack_public_path__ + "img/industry_1.cb331fb8.png";